/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';

export class basecode extends IceEntity {
	key: string = "";
  code: string = "";
  title: string = "";
  description: string = "";
  version: string = "";
  sub_type: number = 0;
  table_name: string = "";

  constructor(tbln: string) {
    super();

    this.table_name = tbln;
  }

  gettablename(): string {
    return this.table_name;
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "DITXML") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "DITXML") return "DrugsResponse,SideEffectsResponse,IngredientsResponse";

    return null;
  }
}
